import { render, staticRenderFns } from "./SiteConfig.vue?vue&type=template&id=51576a66&"
import script from "./SiteConfig.vue?vue&type=script&lang=js&"
export * from "./SiteConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports